import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { UserContext } from '@eas/common-web';
import { AttachmentProvider } from '@composite/attachments/attachment-context';
import { Tabs } from '@composite/tabs/tabs';
import { TabsConfig } from '@composite/tabs/tabs-types';
import { Role } from '@enums';
import { Content } from './fields/content/content';
import { Dispatches } from './fields/dispatches/dispatches';
import { General } from './fields/general/general';
import { History } from './fields/history/history';

export function Fields() {
  const { hasPermission } = useContext(UserContext);

  const config: TabsConfig = [
    {
      label: (
        <FormattedMessage
          id="ES__DOCUMENT_OUTGOING__DETAIL__PANEL_TITLE__GENERAL"
          defaultMessage="Obecné"
        />
      ),
      key: 'GENERAL',
      content: <General />,
      validationKeys: ['summary', 'date'],
    },
    {
      label: (
        <FormattedMessage
          id="ES__DOCUMENT_OUTGOING__DETAIL__PANEL_TITLE__CONTENT"
          defaultMessage="Obsah"
        />
      ),
      key: 'CONTENT',
      content: <Content />,
    },
    {
      label: (
        <FormattedMessage
          id="ES__DOCUMENT_OUTGOING__DETAIL__PANEL_TITLE__DISPATCHES"
          defaultMessage="Vypravení"
        />
      ),
      key: 'DISPATCHES',
      content: <Dispatches />,
    },
    ...(hasPermission(Role.ADMIN)
      ? [
          {
            label: (
              <FormattedMessage
                id="ES__DOCUMENT_OUTGOING__DETAIL__PANEL_TITLE__HISTORY"
                defaultMessage="Historie"
              />
            ),
            key: 'HISTORY',
            content: <History />,
          },
        ]
      : []),
  ];

  return (
    <AttachmentProvider>
      <Tabs config={config} />
    </AttachmentProvider>
  );
}
